module.exports = "data:image/webp;base64,UklGRtwAAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSJ4AAAABgGPb2rHn/Kz+r/unENu206XMiFLZtt3ZmIGd9HZS3eB7vzFExARgdOePpOK0JpAktToYkuWuvtW6oU4fQfAuqtumXrr3R2TAlWK7pgZXJD1SpkgqNSj7R0K0Dd8vd6ZIycuhnPk4kPGREO3D9+vIwsSeTaliKNUoQIt074vOgzMl/KNF70FgQQPYT8pyVZ1qB3OtlSj14NRTMJcNAFZQOCAYAAAAUAEAnQEqEAAQAAFAJiWkAAWMAAD+ooAA"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/speaker.webp
// module id = ny07
// module chunks = 3